<template>
    <div>
        <div>
            <b-modal 
            :ok-only="true"
            ok-title="Ok"
            size="xl" v-model="modalShow" title="Imagem vetorizada">
                <div>
                    <div v-html="outSvg"></div>
                </div>
                <div class="text-center">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="downloadSVG"
                    >
                        Baixar
                    </button>
                </div>
            </b-modal>
        </div>

        <div class="row text-center">
            <div class="col-sm-12">
                <h2>Rock Art</h2>
            </div>
        </div>

        <div class="row" style="margin-bottom: 4%;" >
            <div
                class="col-sm-6 text-center"
                style="border-right: 2px solid gray;"
            >
                <div class="row" style="min-height: 502px" >
                    <div class="col-sm-12">
                        <div style="display: none;">
                            <input
                                type="file"
                                @change="onFileChange"
                                ref="fileInput"
                                id="fileInput"
                            />
                        </div>

                        <b-overlay :show="loadingImage" rounded="lg">
                            <canvas style="border:1px solid #000000;" :width="width" :height="height" ref="canvas" id="canvas"></canvas>
                        </b-overlay>
                    </div>
                </div>

                <br />

                <div class="row">
                    <div class="col-sm-3">
                        <button
                            type="button"
                            class="btn btn-primary"
                            onclick="document.getElementById('fileInput').click();"
                        >
                            Carregar
                        </button>
                    </div>

                    <div class="col-sm-3">
                        <button
                            type="button"
                            :disabled="!url"
                            @click="undo"
                            class="btn btn-primary"
                        >
                            Desfazer
                        </button>
                    </div>

                    <div class="col-sm-3">
                        <!-- @click="download" -->
                        <a
                            type="button"
                            :disabled="!url"
                            :href="fullurl"
                            target="_blank"
                            class="btn btn-primary"
                        >
                            Baixar
                        </a>
                    </div>

                    <div class="col-sm-3">
                        <button
                            type="button"
                            :disabled="!url"
                            @click="save"
                            class="btn btn-primary"
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-sm-6">
                <div >
                    <h2>::.Realce</h2>

                    <div class="scrollmenu row" style="margin-right: 0.5%;">
                        <b-form-group class="ml-3">
                            <b-form-radio-group
                                v-model="contrast"
                                :options="options"
                                button-variant="primary"
                                size="lg"
                                buttons
                            ></b-form-radio-group>
                        </b-form-group>
                        
                        <br>
                        
                        <input
                            :disabled="contrast === 'RGB'"
                            type="range"
                            class="custom-range ml-3"
                            min="0"
                            max="100"
                            step="1"
                            id="range"
                            v-model="contrastIndex"
                        />
                        <br>
                        <p class="ml-3">{{ contrastIndex }}</p>
                    </div>
                </div>

                <div >
                    <h2>::.Segmentação</h2>

                    <h4 v-if="rgb">{{ rgb }}</h4>

                    <h4 v-if="hex">{{ hex }}</h4>

                    <div class="ml-3 mb-3 mt-3 text-center" v-if="segmentColor" :style="`color: white; background-color: rgb(${segmentColor})`">
                        {{ segmentColor }}
                    </div>

                    <div class="scrollmenu">
                        <b-form-group class="ml-3">
                            <b-form-radio-group 
                            v-model="segmentColor"
                            button-variant="btn-default"
                            size="lg"
                            buttons>
                                <b-form-radio 
                                    v-for="(pallet, index) in pallets"
                                    :key="index"
                                    :value="pallet.text" 
                                    :style="(pallet.text == segmentColor) ? '' : `background-color: ${pallet.color}; color: ${pallet.textColor}`">
                                    {{ pallet.text }}<br/>
                                    {{ pallet.color }}
                                </b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </div>
                </div>

                <div>
                    <h2>::.Vetorização</h2>
                     <div>
                        <div class="ml-3 mb-3 mt-3 text-center" v-if="vectorColor" :style="`color: white; background-color: ${vectorColor}`">
                        {{ vectorColor }}
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <div class="text-center">
                        <b-form-input class="text-center" style="width: 40%; margin: 0 auto;" type="color" v-model="vectorColor" placeholder=""></b-form-input>

                        <button
                            type="button"
                            :disabled="!url"
                            @click="applyVectorize('potrace')"
                            class="btn btn-primary"
                        >
                            Vetorize com a cor selecionada acima
                        </button>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// https://ourcodeworld.com/articles/read/515/how-to-add-image-filters-photo-effects-to-images-in-the-browser-with-javascript-using-lena-js
// https://blog.bitsrc.io/image-manipulation-libraries-for-javascript-187fde1ad5af
import "./../assets/custom.css";
import * as services from './../configs/services';
import Lockr from 'lockr';
import Swal from "sweetalert2";
//import mime from "mime-types";
//import Vibrant from "node-vibrant";
import { uploadImage } from "./../configs/services";
import Bus from "./../configs/bus";
import axios from 'axios';

import potrace from 'potrace';

const STATES = {
    CONTRAST: "CONTRAST",
    SEGMENT: "SEGMENT",
    VECTORIZE: "VECTORIZE",
};

const MAX_WIDTH = 500;

const getHeight = (originalWidth, originalHeight) => {
    let wpercent = MAX_WIDTH/originalWidth
    let hsize = parseInt(originalHeight*wpercent)
    return hsize
}

const convertToRGB = function(myString){
    
    myString = myString.replace(/[^0-9a-z]/gi, '')

    if(myString.length != 6){
        throw "Only six-digit hex colors are allowed.";
    }

    const aRgbHex = myString.match(/.{1,2}/g);
    
    let aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
    
    return aRgb;
}

const myapp = {
    name: "Home",
    data: function() {
        return {
            outSvg: "",
            modalShow: false,

            STATES: STATES,
            rgb: '',
            hex: '',
            loadingImage: false,

            contrastIndex: 1,
            vectorColor: '',
            segmentColor: '',

            image: "",
            canvas: {
                src: ''
            },
            context: "",
            url: "",
            
            width: MAX_WIDTH,
            height: MAX_WIDTH,
            
            pallets: [],

            contrast: '',

            currentStep: '',

            options: [
                { text: 'Equalizar Histograma', value: 'RGB', variant: 'primary' },
                { text: 'COR', value: 'COLOR', variant: 'danger' },
                { text: 'CONTRASTE', value: 'CONTRAST', variant: 'warning' },
            ],
        };
    },
    watch: {
        contrastIndex(newval){
            this.setCurrentStep(STATES.CONTRAST)
        },
        contrast(newval){
            this.setCurrentStep(STATES.CONTRAST)
        },
        segmentColor(newval){
            this.setCurrentStep(STATES.SEGMENT)
        },
        // vectorColor(newval){
        //     this.setCurrentStep(STATES.VECTORIZE)
        // },
        fullurl(newval){
            const vm = this;
            this.$nextTick(() => {
                vm.redrawImage();
            })
        }
    },
    computed: {
        id(){
            let list = this.url.split("/");
            return list[list.length-1] || '';
        },
        fullurl(){
            return this.url + '?' 
            + (this.segmentColor ? `segment_color=${this.segmentColor}&` : '')
            //+ (this.vectorColor ? `vector_color=${convertToRGB(this.vectorColor)}&` : '')
            + (this.contrastIndex ? `contrast_index=${this.contrastIndex}&` : '')
            + (this.contrast ? `contrast=${this.contrast}&` : '')
        }
    },
    mounted() {
        const vm = this;

        let item = Lockr.get("image");
        
        console.log(item);

        if(item){
            vm.updateImage(item);
        }

        Bus.$on("image", payload => {
            console.log(payload)
            Bus.$emit("close-modal", null);
            vm.updateImage(payload);
        });

        this.canvas = document.getElementById("canvas");
        this.canvas.height = this.canvas.width = 500;
        this.context = this.canvas.getContext("2d");

        if(this.canvas.addEventListener)
            this.canvas.addEventListener( "click", this.clickhandler, false );
    },
    methods: {
        downloadSVG(){
            let svgBlob = new Blob([this.outSvg], {type:"image/svg+xml;charset=utf-8"});
            let svgUrl = URL.createObjectURL(svgBlob);
            let downloadLink = document.createElement("a");
            downloadLink.href = svgUrl;
            downloadLink.download = "output.svg";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        },
        setCurrentStep(flag){
            this.currentStep = flag;
        },
        startLoading(){
            this.loadingImage = true;
        },
        stopLoading(){
            this.loadingImage = false;
        },
        clickhandler(e) {
            let position = this.findPos(this.canvas);
            
            let x = e.pageX - position.x;
            let y = e.pageY - position.y;
            
            let coordinate = `x=${x}, y=${y}`;
            
            let canvas = this.canvas.getContext('2d');
            
            let p = canvas.getImageData(x, y, 1, 1).data;
            let hex = "#" + ("000000" + this.rgbToHex(p[0], p[1], p[2])).slice(-6);
            
            let rgb = `(${p[0]}, ${p[1]}, ${p[2]})`;
            
            this.hex = hex;
            this.rgb = rgb;
        },
        findPos(obj){
            let current_left = 0, current_top = 0;
            if (obj.offsetParent){
                do {
                    current_left += obj.offsetLeft;
                    current_top += obj.offsetTop;
                    obj = obj.offsetParent;
                    //console.log(obj.offsetParent)
                } while(obj.offsetParent);
                return {x: current_left, y: current_top};
            }
            return undefined;
        },
        rgbToHex(r, g, b){
            if (r > 255 || g > 255 || b > 255)
                throw "Invalid color component";
            return ((r << 16) | (g << 8) | b).toString(16);
        },

        redrawImage(){
            this.updateImage(this.url);
        },
        
        //
        applyVectorize(type) {
            const vm = this;

            vm.startLoading();

            this.setCurrentStep(STATES.VECTORIZE);
            let trace = new potrace.Potrace();
            //console.log('VECTOR');
            let params = {
                background: 'white',
                color: this.vectorColor,
                threshold: 120
            };

            potrace.trace(this.fullurl, params, function(err, svg) {
                if (err) throw err;
                
                vm.modalShow = true;

                vm.outSvg = svg;

                vm.stopLoading();
            });
        },

        undo() {
            this.contrast = '';
            this.contrastIndex = 1;
            this.vectorColor = '';
            this.segmentColor = '';
        },

        save() {

            axios
            .get(this.fullurl + 'save=1')
            .then(data => {
                Swal.fire("Sucesso!", "Imagem salva com sucesso", "success");
            })
            .catch(this.errorHandler)
            // Save on DB:
        },

        getColors() {
            const vm = this;
            axios
            .get(this.fullurl + 'palette=1')
            .then(data => data.data)
            .then(data => {
                vm.pallets = [];
                data.colors.forEach(color => {
                    let hex = vm.rgbToHex(color[0], color[1], color[2]);

                    vm.pallets.push({
                        text: color,
                        color: '#'+hex,
                        textColor: 'white',
                        value: color,
                    });
                });
            })
            .catch(err => console.log(err));
        },

        updateImage(url) {
            const vm = this;

            vm.url = url;

            vm.canvas.src = vm.fullurl;

            let image = new Image();

            let reader = new FileReader();

            vm.image = true;

            image.src = vm.fullurl;

            let fullurl = image.src;

            vm.getColors();

            image.crossOrigin = "Anonymous";

            vm.startLoading();

            image.onload = e => {
                let result = e.target.result;

                vm.canvas.height = vm.canvas.width = vm.width;

                vm.$nextTick(() => {
                    
                    vm.context = vm.canvas.getContext("2d");
                    vm.height = getHeight(vm.canvas.width, vm.canvas.height);
                    vm.context.drawImage(image, 0, 0, vm.width, vm.height);

                    vm.isActive = false;
                    
                    Lockr.set("image", url);

                    vm.stopLoading();
                });
            };
        },

        onFileChange(e) {
            const vm = this;
            let files = e.target.files || e.dataTransfer.files;
            vm.isActive = true;

            if (files.length == 0) return;
            else {
                let file = files[0];

                //
                Bus.$emit("toggle", null);

                uploadImage(file)
                    .then(item => {
                        Lockr.set("image", item.path);
                        vm.updateImage(item.path);
                    })
                    .catch(err => {
                        console.log(err)
                        let message = err.response.data.msg;

                        Swal.fire("Erro!", message || "Error", "error");
                    })
                    .then(() => {
                        Bus.$emit("toggle", null);
                    });
            }
        },

        removeImage: function() {
            this.image = "";

            if (this.context)
                this.context.clearRect(0, 0, this.width, this.height);
        },

        downloadFile() {
            let file = document.getElementById("fileInput").files[0];

            if (file) {
                let fr = new FileReader();
                fr.readAsDataURL(file);

                let blob = new Blob([file], { type: file.type });

                let objectURL = window.URL.createObjectURL(blob);
                console.log(objectURL);

                if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                    window.navigator.msSaveOrOpenBlob(blob, file.name);
                } else {
                    let link = document.createElement("a");
                    link.href = objectURL;
                    link.download = file.name;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
            }
        }
    }
};

export default myapp;
</script>

<style>
#canvas {
    border: 1px solid gray;
}

div.scrollmenu {
    overflow: auto;
    white-space: nowrap;
}

div.scrollmenu button {
    display: inline-block;
    text-align: center;
    padding: 14px;
    margin-left: 2%;
    text-decoration: none;
}

div[disabled] {
  pointer-events: none;
  opacity: 0.7;
}
</style>
